import React, { useEffect } from "react";
import { useState } from "react";
import Button from "../../../Components/Common/FormElements/Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaste } from "@fortawesome/free-regular-svg-icons";
import { faCheckSquare } from "@fortawesome/free-regular-svg-icons";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TextInput from "../../Common/FormElements/TextInput/TextInput";
import { payOrder } from "../../../REDUX/actions/commandes";

function IBANinput() {
  const { t } = useTranslation("common");
  const [show, setShow] = useState(false);
  const [copied, setcopied] = useState(false);
  const [isAcompte, setisAcompte] = useState(false);
  const [acompteAmount, setacompteAmount] = useState();

  const { cart, cartLoading } = useSelector((state) => state.catalogueReducer);
  const { payLoading } = useSelector((state) => state.commandeReducer);
  const { user } = useSelector((state) => state.userReducer);

  const [formData, setFormData] = useState({
    sandbox: false, // if true test version
    websiteId: "sfakd8f06mdx3n6uhm1u763s",
    firstName: "",
    lastName: "",
    email: "",
    city: "",
    address1: "",
    address2: "",
    zipCode: "",
    mobileCountryCode: "+33",
    mobilePhone: "",
    orderRef: "",
    totalAmount: 0,
    numProducts: 0,
    devise: "978",
    codePays: "250",
  });
  const sumPaiements = cart?.payments?.reduce(
    (acc, { amount }) => acc + +amount,
    0
  );

  useEffect(() => {
    setFormData({
      ...formData,
      orderRef: cart?.id?.toString() + "/" + cart?.number,
      firstName: cart?.particulier
        ? cart?.particulierName
        : cart?.majorAccountOrder
        ? cart?.reseller?.name
          ? cart?.reseller?.name
          : cart?.majorAccountName
        : cart?.reseller?.name,
      lastName: " ",
      email: cart?.creator?.email,
      // email: "sabrine@tekand.me",
      city: cart?.addresseDeFacturation?.city?.name,
      address1: `${cart?.addresseDeFacturation?.street}`,
      address2: `${cart?.addresseDeLivraison?.street}`,
      zipCode: cart?.addresseDeFacturation?.zip ?? "",
      mobilePhone: cart?.reseller?.phoneNumber,
      totalAmount: (acompteAmount ? acompteAmount : cart?.totalTTC) * 100,
      numProducts: cart?.groupedPackings?.reduce(
        (acc, current) => acc + current.numberOfProducts,
        0
      ),
    });
  }, [acompteAmount]);

  const dispatch = useDispatch();

  const handleClick = () => {
    setShow(!show);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setcopied(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);
  const inputValue = show
    ? "FR76 1680 6048 2166 1022 7360 690"
    : "**** **** **** **** **** **** ***";
  const iconClassName = !show ? "bi bi-eye-fill" : "bi bi-eye-slash-fill";

  const handleChange = (e) => {
    setacompteAmount(e.target.value);
  };

  const handleClickPay = () => {
    dispatch(payOrder(formData));
  };

  const handleSwitchIsAcompte = () => {
    setisAcompte(true);
  };

  const handleClickPayAcompte = () => {
    if (acompteAmount) {
      setFormData({ ...formData, totalAmount: acompteAmount });
      dispatch(payOrder(formData));
    }
  };
  const [isInvalidValidSoldAmount, setisInvalidValidSoldAmount] = useState();

  useEffect(() => {
    setisInvalidValidSoldAmount(
      cart?.payments?.length >= 1 &&
        +acompteAmount !== +cart?.totalTTC?.toFixed(2) - +sumPaiements
    );
  }, [acompteAmount, cart?.payments, sumPaiements, cart?.totalTTC]);

  return (
    <div className="d-flex flex-column">
      <div className="d-flex">
        <div className="d-flex flex-1">
          <input
            type="text"
            className="ibanInput br5 p-3 b-1-darkGrey w100"
            value={inputValue}
            disabled
          />
          <div
            onClick={handleClick}
            className="inputEye pointer br50 p-2 d-flex align-items-center justify-content-center"
          >
            <i className={iconClassName} />
          </div>
        </div>
        <Button
          RightIcon={() => (
            <FontAwesomeIcon icon={copied ? faCheckSquare : faPaste} />
          )}
          className="ms-3"
          onClick={() => {
            setcopied(true);
            navigator.clipboard.writeText("FR76 3000 6000 0112 3456 7890 189");
          }}
        >
          {copied ? t("IBAN copied") : t("Copy IBAN")}
        </Button>

        {!isAcompte &&
          cart?.payments?.length === 0 &&
          !cart?.free &&
          ["854", "909", "802"].includes(user?.id) && ( // only for sabrine and benjamin PROD : admin / sabrine / benjamin
            // user?.attributes?.userRole === 1 &&
            <Button
              className="ms-3"
              onClick={handleClickPay}
              loading={payLoading}
            >
              {t("Pay Total CC")}
            </Button>
          )}
        {+sumPaiements < +cart?.totalTTC?.toFixed(2) &&
          !cart?.free &&
          ["854", "909", "802"].includes(user?.id) && ( // only for sabrine and benjamin PROD
            // +cart?.totalTTC?.toFixed(2) >= 2000 &&
            <Button
              className="ms-3"
              onClick={handleSwitchIsAcompte}
              loading={payLoading && isAcompte}
            >
              {+cart?.totalTTC?.toFixed(2) - +sumPaiements <
              +cart?.totalTTC?.toFixed(2)
                ? t("Pay balance CC")
                : t("Pay a Deposit CC")}
            </Button>
          )}
        {isAcompte && !cart?.free && (
          // user?.attributes?.userRole === 1 &&
          // +cart?.totalTTC?.toFixed(2) >= 2000 && (
          <div className="ms-3 d-flex gap-3">
            <TextInput
              surfixText="€"
              type="number"
              value={acompteAmount}
              callback={handleChange}
              className={"align-self-end"}
              width={"150px"}
              minHeight={"58px"}
              placeholder={t("Amount")}
            />
            <Button
              onClick={handleClickPayAcompte}
              disabled={
                +acompteAmount > +cart?.totalTTC?.toFixed(2) - +sumPaiements ||
                isInvalidValidSoldAmount
              }
            >
              {t("Apply")}
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                setisAcompte(false);
                setacompteAmount();
                setFormData({ ...formData, totalAmount: cart?.totalTTC });
              }}
            >
              {t("Cancel")}
            </Button>
          </div>
        )}
      </div>
      {/* {!cart?.free && +cart?.totalTTC >= 2000 && ( */}
      <div className="d-flex flex-column gap-1 mt-3">
        <span className="align-self-end ">
          {t("Total deposits paid")} :{" "}
          <span className="text-softBlue bold">{sumPaiements} €</span>
        </span>
        <span className="align-self-end ">
          {t("Remaining Amount to Pay")} :{" "}
          <span className="text-softBlue bold">
            {cart?.totalTTC - sumPaiements} €
          </span>
        </span>
      </div>
      {/* )} */}
      {isInvalidValidSoldAmount && (
        <span className="text-red f13 align-self-end mt-2">
          {t("You must pay the remaining balance of the order !")}
        </span>
      )}
    </div>
  );
}

export default IBANinput;
